import dfo from './assets/programs/dfo.svg';
import family from './assets/programs/family.svg';
import it from './assets/programs/it.svg';
import rural from './assets/programs/rural.svg';
import type { IMortgagePropertyRates } from '../../../types/mortgage/data';
import { PRODUCT_TILE_BACKGROUND_DATA_URLS } from './productTileBackgroundDataUrls';
import { resolveStaticImportUrl } from './resolveStaticImportUrl';

export const CTA_HREF = '/ipoteka-main/?cian_source=cian&cian_medium=trap&cian_campaign=mainpage_mortgage_tab';

export const PRODUCT_TILES: {
  rateKey: keyof IMortgagePropertyRates;
  label: string;
  imageSrc: string;
}[] = [
  { rateKey: 'newBuilding', label: 'новостройки', imageSrc: PRODUCT_TILE_BACKGROUND_DATA_URLS.newBuilding },
  { rateKey: 'used', label: 'вторичка', imageSrc: PRODUCT_TILE_BACKGROUND_DATA_URLS.used },
  { rateKey: 'cottage', label: 'дома', imageSrc: PRODUCT_TILE_BACKGROUND_DATA_URLS.cottage },
  { rateKey: 'land', label: 'земельные участки', imageSrc: PRODUCT_TILE_BACKGROUND_DATA_URLS.land },
];

export const PROGRAM_TILES: { rate: number; name: string; imageSrc: string }[] = [
  { rate: 6, name: 'Семейная', imageSrc: resolveStaticImportUrl(family) },
  { rate: 6, name: 'ИТ-специалисты', imageSrc: resolveStaticImportUrl(it) },
  { rate: 3, name: 'Сельская', imageSrc: resolveStaticImportUrl(rural) },
  { rate: 2, name: 'Дальневосточная', imageSrc: resolveStaticImportUrl(dfo) },
];

export const SOCIAL_STEPS: { title: string; description: string }[] = [
  { title: 'Вы заполняете анкету', description: 'Никаких сканов и справок, нужны только паспортные данные' },
  {
    title: 'Банки пришлют предложения через 2 минуты',
    description: 'Это не «рекламные» ставки, а\u00a0реальные условия кредита для вас',
  },
  {
    title: 'Выберите лучшее предложение',
    description: 'Только после этого банк свяжется с\u00a0вами. Никаких других звонков.',
  },
];
